/* global Word */
export type DocumentParagraph = {
  _paragraph: Word.Paragraph;
  _originalText?: string;
  _currentText?: string;
  _index?: number;
  text: string;
  id: string;
  hash: string;
  fullText: string;
};

/**
 * Parameters for the search function used to locate text or paragraphs within a Word document.
 *
 * @property context The Word.RequestContext instance for interacting with the Word document.
 * @property paragraphId (Optional) The unique identifier of the paragraph to search within.
 * @property paragraph (Optional) The DocumentParagraph object to search within.
 * @property text (Optional) The text string to search for in the document or paragraph.
 * @property options (Optional) Additional search options, such as match case or whole word, as defined by Word.SearchOptions.
 * @property textSearch (Optional) If true, performs a text-based search; otherwise, just paragraph search.
 * @property fallbackToParagraphWhenTextNotFound (Optional) If true, falls back to returning the paragraph if the text is not found.
 * @property fuzzySearch (Optional) If true, enables fuzzy search to allow approximate matches.
 */
export type SearchFnParams = {
  context: Word.RequestContext;
  paragraphId?: string;
  paragraph?: DocumentParagraph;
  text?: string;
  options?: Partial<Word.SearchOptions>;
  textSearch?: boolean;
  fallbackToParagraphWhenTextNotFound?: boolean;
  fuzzySearch?: boolean;
};

export enum OfficeEnvironment {
  Desktop = "Desktop",
  Online = "Online",
}
